module.exports = __webpack_public_path__ + "static/media/departure.cc1b8442.png";